import React, { Component } from 'react';
import { Box, Grid } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';


import FilterPanel from './FilterPanel';
import TableDialog from './TableDialog';
// import CustomDialog from './CustomDialog'


const SPACE_OFFSET = 20
const columns = [
  { field: 'stn', headerName: 'รหัสสถานี', filterable: false, width: 100+SPACE_OFFSET },
  { field: 'name', headerName: 'ชื่อสถานี', filterable: false, width: 100+SPACE_OFFSET },
  { field: 'address', headerName: 'ที่ตั้ง', filterable: false, width: 250+SPACE_OFFSET },
  { field: 'stn_date', headerName: 'วันที่', filterable: false, width: 100+SPACE_OFFSET },
  { field: 'wl07h', headerName: 'ระดับน้ำ', filterable: false, width: 75+SPACE_OFFSET },
  { field: 'rain07h', headerName: 'ฝน', filterable: false, width: 75+SPACE_OFFSET },
  { field: 'soil107h', headerName: 'ความชื้น', filterable: false, width: 75+SPACE_OFFSET },
  { field: 'temp07h', headerName: 'อุณหภูมิ', filterable: false, width: 75+SPACE_OFFSET },
];


class DataPanel extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      isModalOpen: false,
      selectedStn: null,
      filter: this.props.filter,
      area: [],
      currentStation: [],
      filteredStations: []
    };
    this.onCloseModal = this.onCloseModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  async componentDidMount() {
    await this.setState({
      area: this.props.area,
      currentStation: this.props.current,
    })
    await this.filterStation()
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.current.length !== this.props.current.length){
      await this.setState({
        area: this.props.area,
        currentStation: this.props.current,
      })
      await this.filterStation()
    }
  }

  async filterStation() {
    let filterdStation = this.state.currentStation
    if(this.state.filter.dwr_region!==null) {
      filterdStation = filterdStation.filter(d=>d.dwr_region===this.state.filter.dwr_region)
    }
    if(this.state.filter.dopa_region!==null) {
      filterdStation = filterdStation.filter(d=>d.dopa_region===this.state.filter.dopa_region)
    }
    if(this.state.filter.province!==null) {
      filterdStation = filterdStation.filter(d=>d.province===this.state.filter.province)
    }
    if(this.state.filter.amphoe!==null) {
      filterdStation = filterdStation.filter(d=>d.amphoe===this.state.filter.amphoe)
    }
    if(this.state.filter.tambon!==null) {
      filterdStation = filterdStation.filter(d=>d.tambon===this.state.filter.tambon)
    }
    filterdStation.forEach((o) => {
      let address = ''
      if(o['tambon']) address += ` ต.${o['tambon']}`
      if(o['amphoe']) address += ` อ.${o['amphoe']}`
      if(o['province']) address += ` จ.${o['province']}`
      o['address'] = address
    })
    await this.setState({
      filteredStations: filterdStation,
    })
  }

  async openModal(stn) {
    await this.setState({
      isModalOpen: true,
      selectedStn: stn,
    })
  }

  async onCloseModal() {
    await this.setState({
      isModalOpen: false,
      selectedStn: null,
    })
  }
  
  onFilterChange = (value) => {
    this.props.onFilterChange(value)
    this.setState({filter: value})
    this.filterStation()
  }

  onRowClick = async (params, event) => {
    event.defaultMuiPrevented = true
    this.openModal(params.row)
  }

  render() {
    // console.log(this.state.filteredStations)
    return (
      <Box className="aiml-data" sx={{height: '100%', p:2}}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} sx={{ minHeight: 100 }}>
            {this.state.area.length > 0 &&
              <FilterPanel 
                area={this.state.area}
                filter={this.state.filter}
                filteredStations={this.state.filteredStations}
                totalStations={this.state.currentStation}
                onFilterChange={this.onFilterChange}
              />
            }
          </Grid>
          <Grid item xs={12} md={12} sx={{ minHeight: 800 }}>
            {this.state.filteredStations.length > 0 &&
                <DataGrid 
                  getRowId={(row) => row.stn}
                  rows={this.state.filteredStations}
                  columns={columns}
                  components={{ Toolbar: GridToolbar }}
                  onRowClick={this.onRowClick}
                />
                // <Grid></Grid>
            }
            {
              (this.state.isModalOpen && this.state.selectedStn !== null) &&
              <Box sx={{p:20, m:20}}>
                <TableDialog 
                  isModalOpen={this.state.isModalOpen}
                  selectedStn={this.state.selectedStn}
                  onCloseModal={this.onCloseModal}
                />
              </Box>

            }
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default DataPanel;
